import React, { useEffect } from "react";

export default function Posts() {
  useEffect(() => {
    const handleContextMenu = e => e.preventDefault();
    document.addEventListener("contextmenu", handleContextMenu);
    const handleKeyDown = e => {
      if (
        e.key === "F12" ||
        (e.ctrlKey && e.shiftKey && (e.key === "I" || e.key === "C" || e.key === "J")) ||
        (e.metaKey && e.altKey && e.key.toLowerCase() === "i") ||
        (e.ctrlKey && e.key.toLowerCase() === "u")
      ) {
        e.preventDefault();
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("contextmenu", handleContextMenu);
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  return (
    <section style={{ textAlign: 'center', padding: '3rem 0' }}>
      <h2 style={{ fontSize: '2rem', color: '#2d3748', marginBottom: '1rem', letterSpacing: '0.05em' }}>🚧 Coming Soon 🚧</h2>
      <p style={{ color: '#4a5568', fontSize: '1.2rem', maxWidth: '500px', margin: '0 auto' }}>
        Thoughtful posts and insights will be shared here.<br />
        Stay tuned for updates as I build out this space to share my thoughts, experiences, and learnings.
      </p>
      <div style={{ marginTop: '2rem', display: 'flex', justifyContent: 'center', gap: '1rem' }}>
        <span style={{ display: 'inline-block', width: '12px', height: '12px', borderRadius: '50%', background: '#ecc94b', animation: 'pulse 1.5s infinite alternate' }}></span>
        <span style={{ display: 'inline-block', width: '12px', height: '12px', borderRadius: '50%', background: '#68d391', animation: 'pulse 1.5s 0.5s infinite alternate' }}></span>
        <span style={{ display: 'inline-block', width: '12px', height: '12px', borderRadius: '50%', background: '#63b3ed', animation: 'pulse 1.5s 1s infinite alternate' }}></span>
      </div>
    </section>
  );
} 